import IconAddon from "@Icons/ticket/addons/IconAddon";
import React from "react";
import {VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonData.type";
import useGetVehicleTotalPrice
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleType/hooks/useGetVehicleTotalPrice";
import Row from "@Containers/components/Row";
import useCurrency from "@Currency/hooks/useCurrency";

interface VehicleTypeOptionProps {
    option: { value: number, label: string, activeGroup: VehicleAddonResponseType },
    setVehicleType: (value) => void,
}

function VehicleTypeOption({option, setVehicleType}: VehicleTypeOptionProps) {
    const {getAddonPrice} = useGetVehicleTotalPrice()
    const {sign} = useCurrency()

    return (
        <button
            type="button"
            key={option.value}
            value={option.value}
            onClick={() => setVehicleType(option)}
            className="gb--select__option full-width"
        >
            <Row gap center>
                <IconAddon
                    title={option.activeGroup.iconModel.title}
                    width="20"
                    height="20"
                />
                {option.label}
            </Row>
            <p>
                {`+${getAddonPrice(option.value)} ${sign}`}
            </p>
        </button>
    )
}

export default VehicleTypeOption